import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizTextarea,
  WizEventManager, WizEvent, WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { FunctionObj, MeasModeItem, MeasureCoreEngine } from '@wizeoo/akm-compute-lib';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  // zone de saisie des éléments de fonction
  selector: 'formula-editor-input',
  templateUrl: './formula-editor.input.html',
})
export class FormulaEditorInput extends WizBasePopUp implements AfterViewInit {
  // @ViewChild('descDiv') descDiv: ElementRef; // la div de détail des formules / fonctions
  @ViewChild('mainEdit', { read: WizTextarea }) mainEdit: WizTextarea;

  public source: FunctionObj; // la fonction source
  public paramIdx: number; // l'indice du paramètre
  public currentFormula: string; // le contenu du paramètre
  public currentDescHtml: SafeHtml = ''; // le contenu de la div de description

  public focusCallback: Function; // signaler la prise de focus

  public lastInfiniteParamFromVoid: boolean = false; // c'est le dernier paramètre, il était vide, il ne l'est plus
  // public infiniteEmpty: boolean = false;

  constructor(public elementRef: ElementRef, private sanitizer: DomSanitizer) {
    super();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.source = this.datas[0];
      this.paramIdx = this.datas[1];
      this.currentFormula = this.source.contents[this.paramIdx];
      this.callback = this.datas[2];
      this.focusCallback = this.datas[3];
      this.feed();
      this.addListeners();
      if (this.paramIdx === 0) {
        this.mainEdit.wizFocus();
        this.checkCaret();
      }
    }, 0);
  }

  /** alimentation des composants */
  private feed(): void {
    let paramTitle: string = WizTranslationManager.getInstance().translateKey('$.formula.parameter.idx.$', [
      (this.paramIdx + 1).toString(),
    ]);
    let paramKind: string;
    if (this.source.unlimitedParameters) {
      paramKind = this.source.unlimitedParametersKind;
    } else {
      paramKind = this.source.parameters[this.paramIdx]; // TODO gestion de la configuration alternative
    }

    paramKind = WizTranslationManager.getInstance().translateKey('$.function.parameter.' + paramKind + '.$');
    paramTitle += ' (' + paramKind + ')';
    this.mainEdit.wizLabel = paramTitle;
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.mainEdit, WIZ_EVENT_TYPE.CHANGE, this.updateFunctionRenderer);
  }

  /** détection de la position du caret pour réplique sur la formule complète en span */
  public checkCaret(): void {
    this.focusCallback(this.mainEdit); // alimenter le compo ayant le focus
  }

  /**
   * changement dans les zones d'édition, répercussion sur la zone de formule
   * @param e change sur une zone
   */
  private updateFunctionRenderer(e: WizEvent): void {
    this.lastInfiniteParamFromVoid = false;
    if (this.source.unlimitedParameters && this.source.mmi.c.length - 1 <= this.paramIdx) {
      if (!this.currentFormula || this.currentFormula.length === 0) {
        this.lastInfiniteParamFromVoid = true;
      }
    }

    // console.log('updateFunctionRenderer', this.mainEdit.wizValue, this.paramIdx);
    this.currentFormula = this.mainEdit.wizValue;

    if(this.source.mmi.c.length <= this.paramIdx) { // manque des params, je les injecte
      while(this.source.mmi.c.length <= this.paramIdx) {
        const neoMMi: MeasModeItem = MeasureCoreEngine.buildRawMMI(this.source.mm, '');
      this.source.mmi.c.push(neoMMi);
      }
    }
    try {
      this.source.mmi.c[this.paramIdx].form = this.currentFormula;
    } catch(e: any) {
      console.log('err', this.source.mmi.c?.length, this.paramIdx, this.currentFormula);
    }
    
    this.callback(this); // mise à jour de la fonction de base
  }
}
